(function(){

    var melaPlayer = new MelaVideoPlayer('mediaContainer','mediaplayer',360,640, coremetricsCategory);

    var videoSetup = {
        // Media
        Video : depositVideo,
        // Player Properties
        PreventSeeking : false, // Defaults to False
        // ShowCustomProgressBar : true, // Defaults to False
        Autostart : true, // Defaults to False
        ScrollToTop: true, // Defaults to False
        RecordingInterval: 10, // Minimum of 2 seconds, Defaults to 10 seconds if nothing is passed. A -1 means that recording should not occur
        CanResumePlay: true, // Defaults to False
        FeatureID: 2, // If one is not passed we just set it to 0 (Undefined) as the table requires a feature.
        //Events
        OnReadyFunction : function(event) {
            //alert("OnReadyFunction");
        },
        OnFirstLaunchFunction : function(event) {
            //alert("OnFirstLaunchFunction");
        },
        OnFirstResumeFunction: function () { // Because of the way FirstResume is implemented, there is not and "event" parameter like the others.
            //alert("OnFirstResumeFunction");
        },
        OnPlayFunction : function(event) {
        },
        OnPauseFunction : function(event) {
            //alert("OnPauseFunction");
        },
        OnCompleteFunction : function(event) {
        },
        OnPlayProgressFunction : function(event) {
            //alert("OnPlayProgressFunction");
        }
    };

    // Events
    melaPlayer.SetupVideo(videoSetup);

}());


